// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__bwjnK","children":"Checkbox_children__DJcW2","effect":"Checkbox_effect__Rd0ao","scaleUp":"Checkbox_scaleUp__6hYW6"};